// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-button-container {
  position: fixed;
  bottom: 62px;
  right: 32px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
@media (max-width: 999px) {
  .call-button-container{
    right: 20px;
  }
}
/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .call-button-container{
    right: 10px;
  }
}
.call-button {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--color-accent); /* Зеленый цвет */
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.call-button:hover {
  transform: scale(1.1);
  background-color: #45a049;
}

.phone-icon {
  font-size: 24px;
  /* Анимация пульсации */
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.95);
  }
}

.call-text {
  background-color: var(--color-base-gray);
  color: #333;
  padding: 7px 10px;
  border-radius: var(--border-radius-lg);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  margin-right: 10px;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s ease;
  position: absolute;
  right: 70px;
  white-space: nowrap;
}

/* Добавляем треугольник с помощью псевдоэлемента */
.call-text::after {
  content: '';
  position: absolute;
  right: -10px; /* Позиция треугольника */
  top: 50%;
  transform: translateY(-50%);
  border-left: 10px solid var(--color-base-gray); /* Треугольник того же цвета, что и фон */
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 0;
}

.call-text.show {
  opacity: 1;
  transform: translateX(0);
}

/* Стили для модального окна */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 400px;
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #aaa;
}

.close-button:hover {
  color: #333;
}

h2 {
  margin-top: 0;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #555;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

.submit-button {
  background-color: var(--color-accent);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: var(--color-accent-pressed);
} `, "",{"version":3,"sources":["webpack://./src/components/Buttons/CallButton/CallButton.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA,yCAAyC;AACzC;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC,EAAE,iBAAiB;EACxD,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY,EAAE,yBAAyB;EACvC,QAAQ;EACR,2BAA2B;EAC3B,8CAA8C,EAAE,yCAAyC;EACzF,iCAAiC;EACjC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".call-button-container {\n  position: fixed;\n  bottom: 62px;\n  right: 32px;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n@media (max-width: 999px) {\n  .call-button-container{\n    right: 20px;\n  }\n}\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .call-button-container{\n    right: 10px;\n  }\n}\n.call-button {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: var(--color-accent); /* Зеленый цвет */\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 2;\n}\n\n.call-button:hover {\n  transform: scale(1.1);\n  background-color: #45a049;\n}\n\n.phone-icon {\n  font-size: 24px;\n  /* Анимация пульсации */\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(0.95);\n  }\n}\n\n.call-text {\n  background-color: var(--color-base-gray);\n  color: #333;\n  padding: 7px 10px;\n  border-radius: var(--border-radius-lg);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  margin-right: 10px;\n  opacity: 0;\n  transform: translateX(20px);\n  transition: all 0.3s ease;\n  position: absolute;\n  right: 70px;\n  white-space: nowrap;\n}\n\n/* Добавляем треугольник с помощью псевдоэлемента */\n.call-text::after {\n  content: '';\n  position: absolute;\n  right: -10px; /* Позиция треугольника */\n  top: 50%;\n  transform: translateY(-50%);\n  border-left: 10px solid var(--color-base-gray); /* Треугольник того же цвета, что и фон */\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-right: 0;\n}\n\n.call-text.show {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* Стили для модального окна */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  width: 90%;\n  max-width: 400px;\n  position: relative;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #aaa;\n}\n\n.close-button:hover {\n  color: #333;\n}\n\nh2 {\n  margin-top: 0;\n  color: #333;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n  color: #555;\n}\n\ninput {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.submit-button {\n  background-color: var(--color-accent);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 10px;\n  transition: background-color 0.3s;\n}\n\n.submit-button:hover {\n  background-color: var(--color-accent-pressed);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
